import { useMemo, useRef } from 'react'
import { downloadFile } from '../../../helpers/FileDownload'
import { useLazyGetOrderDocumentQuery } from '../../../redux/api/ordersApi'
import { IElementProps } from '../../../types/interfaces'
const Upload = (props: IElementProps) => {
  const [getOrderDocument] = useLazyGetOrderDocumentQuery()
  const inputRef = useRef<HTMLInputElement>(null)

  const remove = () => {
    props.handleChange(props.name)
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  const download = async (docId: string, docName: string) => {
    const response = await getOrderDocument({
      orderId: props.order.id,
      documentId: docId,
    }).unwrap()
    const file = new Blob([response.data], { type: 'application/octet-stream' })
    const fileURL = URL.createObjectURL(file)
    downloadFile({
      fileURL,
      filename: docName,
    })
  }

  const documentId = useMemo(() => {
    return props.value?.startsWith('$doc:') ? props.value?.replace('$doc:', '') : undefined
  }, [props.value])

  const documentName = useMemo(() => {
    return documentId
      ? props.order.documents.find((doc) => doc.id === documentId)?.fileName
      : props.value?.split('|').at(0)
  }, [documentId, props.order.documents, props.value])

  return (
    props.visible && (
      <div className="formGroup">
        <div className="labelTooltip">
          {props.translatedTooltip && (
            <>
              <div className="tooltipArea">
                <i className="icon-info"></i>
                <div className="tooltip">{props.translatedTooltip}</div>
              </div>
            </>
          )}
          <label>{props.label}</label>
        </div>
        <input
          disabled={props.formReadOnly}
          style={{ display: props.value ? 'none' : undefined }}
          ref={inputRef}
          id="upload"
          type="file"
          onChange={(e) => {
            const fileSizeBytes = e.target.files?.[0]?.size ?? 0
            const fileSizeMegabytes = fileSizeBytes / 1024 / 1024
            const tooBig = fileSizeMegabytes > 8
            props.handleChange(props.name, e, tooBig)
            if (tooBig && inputRef.current) {
              inputRef.current.value = ''
            }
          }}
          className="required-highlight"
        />
        {!!documentName && <div className="filename">{documentName}</div>}
        {!!documentName && (
          <div className="buttonAreaSmall">
            <button disabled={props.formReadOnly} onClick={remove}>
              <i className="icon-clear" /> <span>Delete file</span>
            </button>
            {!!documentId && (
              <button onClick={() => download(documentId, documentName)}>
                <i className="icon-download" /> <span>Download file</span>
              </button>
            )}
          </div>
        )}
      </div>
    )
  )
}
export default Upload
